import { Component } from '@angular/core';

@Component({
  selector: 'process-overlay',
  templateUrl: 'process-overlay.html',
  styleUrls: ['process-overlay.scss']
})
export class ProcessOverlayComponent {}
